import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Row, Col } from 'reactstrap';

import { ColorArea } from './assets/styleds';
import { chartExample6 } from 'variables/charts.js';
import CountUp from 'react-countup';
import DefaultModal from 'components/Modal/DefaultModal';
import AccountsListTable from './AccountsListTable';

const GraphicAccountsStatus = ({ accountsCountBySeller }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalAccounts, setModalAccounts] = useState([]);

  const totalActive = accountsCountBySeller
    ? accountsCountBySeller.reduce(
        (sum, item) => sum + Number(item.activeCount),
        0
      )
    : 0;
  const totalInactive = accountsCountBySeller
    ? accountsCountBySeller.reduce(
        (sum, item) => sum + Number(item.inactiveCount),
        0
      )
    : 0;
  const totalAccounts = totalActive + totalInactive;

  const filteredLabels = ['Ativas', 'Inativas'];
  const filteredData = [totalActive, totalInactive];
  const filteredColors = ['#2ecc40', '#ff4136'];

  const getAccountsList = (type) => {
    if (!accountsCountBySeller) return [];
    let result;
    if (type === 'active') {
      result = accountsCountBySeller.flatMap(
        (item) => item.activeAccounts || []
      );
    } else {
      result = accountsCountBySeller.flatMap(
        (item) => item.inactiveAccounts || []
      );
    }
    return result;
  };

  const handleOpenModal = (type) => {
    setIsModalOpen(true);
    if (type === 'active') {
      setModalTitle('Contas Ativas');
      setModalAccounts(getAccountsList('active'));
    } else {
      setModalTitle('Contas Inativas');
      setModalAccounts(getAccountsList('inactive'));
    }
  };

  const handlePieClick = (elements) => {
    if (elements && elements.length > 0) {
      const idx = elements[0]._index;
      if (idx === 0) handleOpenModal('active');
      if (idx === 1) handleOpenModal('inactive');
    }
  };

  return (
    <>
      <Row>
        <Col md="4" style={{ alignSelf: 'center' }}>
          <div className="chart">
            <Pie
              data={{
                labels: filteredLabels,
                datasets: [
                  {
                    data: filteredData,
                    backgroundColor: filteredColors
                  }
                ]
              }}
              options={{
                ...chartExample6.options
              }}
              onElementsClick={handlePieClick}
              className="chart-canvas"
              id="chart-doughnut"
            />
          </div>
        </Col>

        <Col md="8">
          <Row>
            <Col md="12">
              <h1 className="display-1">
                <CountUp end={totalAccounts} />
              </h1>
              <h2 className="text-muted font-weight-light mt--3">
                Total de Contas
              </h2>
            </Col>
          </Row>

          <hr />

          <Row className="mr-0">
            {filteredData.map((data, index) => (
              <Col
                md="2"
                key={index}
                className="mt--3 mb--3"
                style={{
                  minWidth: '177px',
                  minHeight: '130px',
                  cursor: 'pointer'
                }}
                onClick={() =>
                  handleOpenModal(index === 0 ? 'active' : 'inactive')
                }
              >
                <Row
                  className="row flex-nowrap"
                  style={{
                    minHeight: '100px'
                  }}
                >
                  <Col md="1">
                    <ColorArea color={filteredColors[index]} />
                  </Col>
                  <Col md="11">
                    <h2>{filteredData[index]}</h2>
                    <h3 className="text-muted font-weight-light mt--3">
                      {filteredLabels[index] === ''
                        ? '-'
                        : filteredLabels[index]}
                    </h3>
                    <h2
                      className="mt--1 font-weight-light"
                      style={{
                        paddingBottom: '1.5625rem'
                      }}
                    >
                      {totalAccounts
                        ? `${parseFloat(
                            (100 * filteredData[index]) / totalAccounts
                          ).toFixed(2)}%`
                        : '0%'}
                    </h2>
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>

      <DefaultModal
        show={isModalOpen}
        onModalToggle={setIsModalOpen}
        title={modalTitle}
        showCloseButton={false}
        modalContainerClasses=""
      >
        <AccountsListTable accounts={modalAccounts} title={modalTitle} />
      </DefaultModal>
    </>
  );
};

export default GraphicAccountsStatus;
